import React from 'react'

import styled from 'styled-components/native'
import { ProximaNova } from '../../../../App/Components'

type Props = {
  isShowDuration: boolean
  isShowPrice: boolean
  duration: number
  waitTime: number
}

const ActivityMetaDuration = styled(ProximaNova)<{
  highlightcolor: string
  isShowPrice: boolean
  isShowDuration: boolean
}>`
  font-size: 1em;
  width: 50%;
`

export const ActivityDuration = ({
  isShowDuration,
  isShowPrice,
  duration,
  waitTime,
}: Props) => {
  if (!isShowDuration || !duration) {
    return null
  }
  const totalTime: number = duration + waitTime

  return (
    <ActivityMetaDuration
      isShowPrice={isShowPrice}
      isShowDuration={isShowDuration}
    >
      {`${totalTime} min`}
    </ActivityMetaDuration>
  )
}
